export default {
  'Add Cut': 'Tambah Potongan',
}